import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12 d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Ед.изм:", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["value", "onBlur", "onFocus"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату ", -1)
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from "vue";
import { useModal } from "@/composables/useModal";
import { DatePicker } from 'v-calendar';
import api from "@/api";
import { IMaterial } from "@/@types/IMaterial";


export default /*#__PURE__*/_defineComponent({
  __name: 'StockTakingModal',
  props: {
    id: Number,
},
  setup(__props) {

const props = __props;

const modal = useModal(String(props.id));

const materials = ref<IMaterial[]>([]);

const state = reactive({
    title: '',
    id: 0,
    remainsQuantity: '',
    filledAt: '',
    materialId: 0,
    comment: '',
    visibleErrors: false,
    loader: false,
});

const isMaterialIdError = computed(() => !state.materialId);
const isCountError = computed(() => +state.remainsQuantity <= 0);
const isFilledAtError = computed(() => !state.filledAt);

const errors = computed(() => {
    return isMaterialIdError.value || isCountError.value || isFilledAtError.value;
});

onMounted(() => {
    state.title = 'Редактирование';

    api.materials.getOld().then(r => materials.value = r.data);

    if (Object.keys(modal.data?.materialStockTaking || {}).length) {
        state.remainsQuantity = modal.data.materialStockTaking.remainsQuantity;
        state.filledAt = modal.data.materialStockTaking.filledAt;
        state.materialId = modal.data.materialStockTaking.materialId;
        state.comment = modal.data.materialStockTaking.comment;
    }
});

function send() {
    if (errors.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;
    if (!modal.data?.materialStockTaking?.id) {
        return;
    }
    api.materialStockTaking.update(+modal.data.materialStockTaking.id, {
        remainsQuantity: state.remainsQuantity,
        materialId: state.materialId,
        filledAt: state.filledAt,
        comment: state.comment,
    }).then((r: any) => {
        if (r.data) {
            modal.ok(r.data);
        }
    }).finally(() => state.loader = false);
}

function onMaterialSelected(_m: any) {
    state.materialId = _m.id;
}

function onCountEnter() {
    state.remainsQuantity = state.remainsQuantity.replaceAll(',', '.');
}

const handleGetMaterialUnitDimension = computed(() => {
    const material = materials.value.find((m) => m.id === +state.materialId);

    return material?.measurement || '';
});


return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-xl",
    title: state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите наименование ТМЦ",
              label: "Наименование ТМЦ",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isMaterialIdError.value,
                  options: materials.value,
                  placeholder: "Наименование ТМЦ",
                  searchable: true,
                  values: [state.materialId],
                  onOnSelected: _cache[0] || (_cache[0] = (value) => onMaterialSelected(value))
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (state.materialId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(handleGetMaterialUnitDimension.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "-"))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите дату",
              label: "Дата",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  modelValue: state.filledAt,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.filledAt) = $event)),
                  as: "",
                  readonly: "",
                  timezone: 'Asia/Almaty',
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': isFilledAtError.value && state.visibleErrors, 'bg-white': true }]),
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_9),
                      _hoisted_10
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите количество",
              label: "Количество",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.remainsQuantity,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.remainsQuantity) = $event)),
                  mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                  "is-invalid": state.visibleErrors && isCountError.value,
                  onInput: onCountEnter,
                  placeholder: "Количество"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_group_ui, { label: "Примечание" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.comment,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.comment) = $event)),
                  placeholder: "Примечание"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})